import { render, staticRenderFns } from "./SubscriptionRoute.vue?vue&type=template&id=8921d78a&scoped=true&"
import script from "./SubscriptionRoute.vue?vue&type=script&lang=js&"
export * from "./SubscriptionRoute.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionRoute.vue?vue&type=style&index=0&id=8921d78a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8921d78a",
  null
  
)

export default component.exports